export const classes = {
  learningContentDiv: { margin: "4%" },
  alert: { width: "100%", zIndex: 1000 },
};
